module.exports = __webpack_public_path__ + "img/SL410.9083d579.jpeg";